import { z } from 'zod'

/**
 * The brand-id grammar of `@today/brand-config` (`ID_PATTERN`, lowercase kebab-case). Restated
 * here so `@today/models` does not bundle the brand compiler; a test pins the two equal.
 */
export const BRAND_ID_PATTERN = /^[a-z][a-z0-9]*(-[a-z0-9]+)*$/

/** A brand id: {@link BRAND_ID_PATTERN}, 2–64 characters. */
export const brandIdSchema = z.string().min(2).max(64).regex(BRAND_ID_PATTERN)

/**
 * `PUT /admin/tenants/{tenantId}/brand` (TO-380 REQ-004) — SHAPE only: exactly `{ brandId }`,
 * no other key (→ `VALIDATION_ERROR`). Whether the id is a selectable brand is the service's
 * `BRAND_NOT_SELECTABLE` rule.
 */
export const tenantBrandSelectSchema = z.strictObject({ brandId: brandIdSchema })

export type TenantBrandSelectInput = z.infer<typeof tenantBrandSelectSchema>
